import { defineComponent as _defineComponent } from 'vue'
import OzBaseButton from '@@/library/v4/components/OzBaseButton.vue'
import { OzContainedButtonColorScheme } from '@@/library/v4/components/OzContainedButton.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MagicChatIconButton',
  props: {
    darkMode: { type: [Boolean, String], default: 'auto' },
    disabled: { type: Boolean, default: false },
    isActive: { type: Boolean, default: false },
    colorScheme: { default: OzContainedButtonColorScheme.Bare }
  },
  emits: ["click"],
  setup(__props: any) {





return { __sfc: true,OzBaseButton, OzContainedButtonColorScheme, OzIcon }
}

})